/*
 * @Author: handan05
 * @Date: 2022-07-28 11:21:05
 * @LastEditors: handan05
 * @LastEditTime: 2023-04-17 16:15:58
 * @FilePath: /operation-utils/Users/handan/Documents/handan_work/58project/tech/wblog/src/platforms/zcm.ts
 * @Description:
 */
import { isJsonString } from '../../helpers';

/**
 * 触发埋点
 * @param {*} reportParams
 */
function log(reportParams: { opt: any; p: string[] }) {
    const { opt = {}, p = [] } = reportParams || {};

    // p[0]为空，则将extJson作为p[0]
    if (!p[0]) {
        p[0] = JSON.stringify({ pagetype: opt.page_type });
    }

    // p[0]是JSON字符串，则将extJson合并到p[0]中
    if (p[0] && isJsonString(p[0])) {
        const p1 = JSON.parse(p[0]);
        p[0] = JSON.stringify({ ...p1, pagetype: opt.page_type });
    }

    let params: any = {
        key: opt.action_type,
        param1: p[0],
        param2: p[1] || window.location.href,
        param3: p[2] || document.referrer,
        param4: p[3] || ''
    };
    const M_BJOB = (<any>window).M_BJOB;

    // console.log(opt)
    if (!M_BJOB) return;
    M_BJOB && M_BJOB.setZcmTrace && M_BJOB.setZcmTrace(params);
}

export default log;
